import React from "react";
import AdminUsersComponent from "../../components/surgo/AdminUsers";

const AdminUsersPage: React.FC = () => {
  return <AdminUsersComponent />;
};

export default AdminUsersPage;
